import { secureStorage } from './xssProtection.utils';

const AUTH_TOKEN_KEY = 'auth_token';

/**
 * Store authentication token securely in localStorage
 */
export const storeAuthToken = (token: string): void => {
  try {
    secureStorage.setItem(AUTH_TOKEN_KEY, token);
    console.log('Token stored successfully');
  } catch (error) {
    console.error('Failed to store auth token:', error);
  }
};

/**
 * Retrieve authentication token from localStorage
 */
export const getStoredAuthToken = (): string | null => {
  try {
    return secureStorage.getItem(AUTH_TOKEN_KEY);
  } catch (error) {
    console.error('Failed to retrieve auth token:', error);
    return null;
  }
};

/**
 * Remove authentication token from localStorage
 */
export const clearAuthToken = (): void => {
  try {
    secureStorage.removeItem(AUTH_TOKEN_KEY);
    console.log('Token cleared successfully');
  } catch (error) {
    console.error('Failed to clear auth token:', error);
  }
};

/**
 * Check if a stored token exists
 */
export const hasStoredAuthToken = (): boolean => {
  return !!getStoredAuthToken();
};
